module.exports = __webpack_public_path__ + "static/media/loader-orange.73b9436c.gif";